import { render, staticRenderFns } from "./sponsor.vue?vue&type=template&id=51e29516&scoped=true&"
import script from "./sponsor.vue?vue&type=script&lang=js&"
export * from "./sponsor.vue?vue&type=script&lang=js&"
import style0 from "./sponsor.vue?vue&type=style&index=0&id=51e29516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e29516",
  null
  
)

export default component.exports